
export function openPopoutWindow(url: string, title: string) {
  const width = 550;
  const height = 650;
  const left = window.screen.width - width;
  const top = 20;

  const features = [
    `width=${width}`,
    `height=${height}`,
    `left=${left}`,
    `top=${top}`,
    'resizable=yes',
    'scrollbars=yes',
    'status=no',
    'location=no',
    'menubar=no',
    'toolbar=no',
  ].join(',');

  return window.open(url, title, features);
}
